/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { OpportunityEntity } from '@axiom/domain';
import { InterviewStatusType } from '@axiom/domain';
/**
 * Response projection of the Opportunity entity. Extends OpportunityEntity
 * (inherits `static key = 'Opportunity'`), so this projection and the full
 * Opportunity entity merge into the same normalized cache record.
 * dark-roast DTO: OpportunityInterviewResultDto
 * also used by readUsersOpportunitiesInterviews
 */
export class ReadOpportunitiesInterviewsResponseEntity extends OpportunityEntity {
  calendarConversation: Record<string, unknown> | null = null;
  candidateOpportunity: Record<string, unknown> | null = null;
  clientRequest: Record<string, unknown> | null = null;
  override interviewNumber: number = 0;
  override interviewStatus: InterviewStatusType | null = null;
  override opportunityId: string | null = null;
  override salesforceCXLeadId: string | null = null;
  override sortDate: string | null = null;
}